import { UserProfileScreen } from 'screens/profile';

export default UserProfileScreen;
